import { memo } from 'react';
import { Button, TableSelectable } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { Recording } from '../../../store/list/types';
import styled from '@emotion/styled';

const CenterAlignedCell = styled(TableSelectable.Cell)`
  text-align: center;
`;

interface PlayRecordingCellProps {
  recording: Recording;
  onPlay: (recording: Recording) => void;
}

const RecordingsPlayRecordingCell = ({
  recording,
  onPlay,
}: PlayRecordingCellProps): JSX.Element => {
  const { t } = useTranslation();
  const btnCopy = recording.watched ? t('common:player.replay') : t('common:player.play');
  const btnKind = recording.watched ? 'ghost' : 'secondary';
  const iconName = recording.watched ? 'replay' : 'play_alt';

  return (
    <CenterAlignedCell>
      <Button kind={btnKind} size="s" icon={iconName} onClick={() => onPlay(recording)}>
        {btnCopy}
      </Button>
    </CenterAlignedCell>
  );
};

export const PlayRecordingCell = memo(RecordingsPlayRecordingCell);
